import React, { CSSProperties } from 'react';
import { Flex, Spin } from 'antd';

export const DefaultLoader = ({ style }: { style?: CSSProperties }) => {
	return (
		<Flex vertical justify="center" style={style} data-testid="pdf-default-loader">
			<Spin size="large" />
		</Flex>
	);
};
